import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    FormControl, InputLabel, InputAdornment, OutlinedInput, FormControlLabel, Checkbox, ButtonGroup,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import PageTitle from "../components/PageTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {PrintOutlined, RemoveRedEye} from "@mui/icons-material";
import copyObject from "../utils/copyObject";
import Paper from "@mui/material/Paper";
import {useLazyAverageEmployeeGradesOverTheDisciplinesWebReportQuery} from "../store/reports/reportsApi";

export default function AverageEmployeeGradesOverTheDisciplinesWebReportPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [dataRequest] = useLazyAverageEmployeeGradesOverTheDisciplinesWebReportQuery();
    const [data, setData] = useState([]);
    const [examsDate, setExamsDate] = useState(null);
    const [noOutsidePlanPasses, setNoOutsidePlanPasses] = useState(false);
    const [noRetakes, setNoRetakes] = useState(false);

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const loadData = async () => {
        setIsSaving(true);

        const request = {
            noRetakes,
            noOutsidePlanPasses
        };
        console.log(request);

        await dataRequest({data: request}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                console.log(fulfilled)
                setData(copyObject(fulfilled.chairs))
            } else {
                fulfilled.errors?.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsSaving(false);
        }).catch((e) => {
            alert('Ошибка');
            setIsSaving(false);
        });
    };
    
    function avgOverEmployee(employee, type) {
        if (employee.disciplines.length === 0)
            return 0;
        
        let sum = 0;
        employee.disciplines.forEach((item) => {
            if (type === "grade") {
                sum += item.avgGrade;
            } else {
                sum += item.percentageOfAttendedStudents;
            }
        })
        
        console.log('sum',sum);
        return (sum / employee.disciplines.length).toFixed(2);
    }

    function avgOverChair(chair, type) {
        let sum = 0;
        let numberOfItems = 0;
        chair.employees.forEach((employee) => {
            if (employee.disciplines.length === 0)
                return;

            employee.disciplines.forEach((item) => {
                if (type === "grade") {
                    sum += item.avgGrade;
                } else {
                    sum += item.percentageOfAttendedStudents;
                }
                
                numberOfItems += 1;
            })
        });
        
        if (numberOfItems === 0)
            return 0;

        return (sum / numberOfItems).toFixed(2);
    }

    function downloadReport(fileType) {
        setIsLoading(true);
        fetch(`/Reports/AverageEmployeeGradesOverTheDisciplinesPrintableReport?noRetakes=${noRetakes}&noOutsidePlanPasses=${noOutsidePlanPasses}&fileType=${fileType}`,
            {
                method: "GET",
                headers: {
                    "semesterid": localStorage.getItem("selectedSemesterId"),
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`
                }
            }).then(response => {
            setIsLoading(false);
            return response.blob();
        }).then(response => {
            if (response.size < 1024*1) { // отсекаем все, что ниже 10кб
                alert('Не удалось загрузить файл')
                return;
            }

            const url = window.URL.createObjectURL(
                new Blob([response]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `Средние оценки преподавателя по дисциплинам.${fileType}`,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        }).catch((e) => {
            alert('Ошибка')
        })
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Средние оценки преподавателя по дисциплинам`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {isSaving ? <CircularProgress /> : <></>}
                            Средние оценки преподавателя по дисциплинам
                        </Typography>
                        <ButtonGroup size={'small'} variant={'outlined'}>
                            <Button startIcon={isLoading ? <CircularProgress size={15}/> : <PrintOutlined />}
                                    disabled={isLoading}
                                    onClick={() => {downloadReport('pdf')}}>Печать PDF</Button>

                            <Button startIcon={isLoading ? <CircularProgress size={15}/> : <></>}
                                    disabled={isLoading}
                                    onClick={() => {downloadReport('xlsx')}}>XLSX</Button>
                        </ButtonGroup>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Box display="flex" alignItems="center" gap={2}>
                                <FormControlLabel
                                    control={<Checkbox />}
                                    onChange={(event, checked) => setNoRetakes(checked)}
                                    label="Не учитывать пересдачи"
                                />
                                <FormControlLabel
                                    control={<Checkbox />}
                                    onChange={(event, checked) => setNoOutsidePlanPasses(checked)}
                                    label="Не учитывать досрочные и внеплановые сдачи"
                                />
                                <Button variant="contained" onClick={loadData}>
                                    Просмотр
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                    
                    {/* Таблицы кафедр */}
                    {data?.sort((l,r) => l.chairName > r.chairName ? 1 : -1).map((chair, index) => (
                        <Box key={index} mb={4}>
                            <Typography variant="h6" gutterBottom>
                                Кафедра {chair.chairName}
                            </Typography>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Преподаватель</TableCell>
                                            <TableCell>Дисциплина</TableCell>
                                            <TableCell align={'center'}>Средний балл</TableCell>
                                            <TableCell align={'center'}>Посещаемость на экзамене</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {chair.employees?.sort((l,r) => l.employeeFullName > r.employeeFullName ? 1 : -1).map((employee, empIndex) => (
                                            <>
                                                {employee.disciplines?.sort((l,r) => l.courseName > r.courseName ? 1 : -1).map((discipline, discIndex) => (
                                                    <TableRow key={discIndex}>
                                                        {discIndex === 0 && (
                                                            <TableCell
                                                                rowSpan={employee.disciplines.length + (employee.disciplines.length > 1 ? 1 : 0)}
                                                                style={{ verticalAlign: "top" }}
                                                            >
                                                                {employee.employeeFullName}
                                                            </TableCell>
                                                        )}
                                                        <TableCell>
                                                            {discipline.disciplineName} (
                                                            {discipline.courseName})
                                                        </TableCell>
                                                        <TableCell align={'center'}>{discipline.avgGrade.toFixed(2)}</TableCell>
                                                        <TableCell align={'center'}>
                                                            {discipline.percentageOfAttendedStudents.toFixed(2)}%
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                                {employee.disciplines.length > 1
                                                ? <TableRow style={{'backgroundColor': '#F0F0F0'}}>
                                                        <TableCell><strong>По всем дисциплинам</strong></TableCell>
                                                        <TableCell align={'center'}><strong>{avgOverEmployee(employee, 'grade')}</strong></TableCell>
                                                        <TableCell align={'center'}><strong>{avgOverEmployee(employee, 'percentage')}%</strong></TableCell>
                                                    </TableRow>
                                                : <></>}
                                            </>
                                        ))}
                                        <TableRow style={{'backgroundColor': 'lightgray'}}>
                                            <TableCell colSpan={2}><strong>По кафедре</strong></TableCell>
                                            <TableCell align={'center'}><strong>{avgOverChair(chair, 'grade')}</strong></TableCell>
                                            <TableCell align={'center'}><strong>{avgOverChair(chair, 'percentage')}%</strong></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    ))}

                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}
